export default "__VITE_ASSET__CcDH1X$M__"